<p-toast position="top-center" key="tc" />
<p-confirmdialog />

<div *ngIf="loading; else pageDiv" class="me-3 mt-3 w-full">
  <div class="d-flex align-items-center">
    <strong>Caricamento...</strong>
    <p-progress-spinner class="ms-auto" aria-label="Caricamento" [style]="{ width: '5rem', height: '5rem' }" />
  </div>
</div>

<ng-template #pageDiv>
  <p-splitter class="layout-main-container"
              [style]="{'height': '100%'}"
              [panelSizes]="[40, 60]"
              [panelStyle]="{'overflow': 'visible'}">
    <ng-template #panel>
      <div class="grid w-full grid-cols-3 content-start items-center gap-3 p-4">
        <label for="sessionId" class="text-left font-semibold">ID</label>
        <input pInputText id="sessionId" class="col-span-2" [disabled]="true" [(ngModel)]="item.sessionId" />

        <label for="organization" class="text-left font-semibold">Name</label>
        <input pInputText id="organization" class="col-span-2" [disabled]="true" [(ngModel)]="item.organization" />

        <label for="team" class="text-left font-semibold">Name</label>
        <input pInputText id="team" class="col-span-2" [disabled]="true" [(ngModel)]="item.team" />

        <label for="name" class="text-left font-semibold">Name</label>
        <input pInputText id="name" class="orgdept-input col-span-2" [(ngModel)]="item.name" />

        <label for="date" class="text-left font-semibold">Data</label>
        <p-datepicker id="date" [(ngModel)]="item.date" class="col-span-2" [showButtonBar]="true" />

        <label for="description" class="col-start-1 self-start text-left font-semibold">Descrizione</label>
        <textarea id="description" class="col-span-2 self-start" rows="5" cols="30" pTextarea [(ngModel)]="item.description"></textarea>

        <p-button class="col-start-3 justify-self-end" label="Salva" (click)="onSave()" />
      </div>
    </ng-template>
    <ng-template #panel>
      <div class="flex h-full w-full flex-col gap-3 p-3">
        <div class="flex flex-row-reverse">
          <p-button class="col-start-3 justify-self-end" label="Carica Dati" (click)="onShowDialog(newItem)" />
        </div>
        <p-table [value]="sessionFiles" class="w-full">
          <ng-template #header>
            <tr>
              <th style="width:30%">Atleta</th>
              <th style="width:10%; text-align:center">Testa</th>
              <th style="width:10%; text-align:center">Piede Sx</th>
              <th style="width:10%; text-align:center">Piede Dx</th>
              <th></th>
              <th style="width:7%"></th>
              <th style="width:7%"></th>
              <th style="width:7%"></th>
            </tr>
          </ng-template>
          <ng-template #body let-file>
            <tr>
              <td>{{ file.user }}</td>
              <td style="text-align:center"><i [ngClass]="getFileStatus(file.head)"></i></td>
              <td style="text-align:center"><i [ngClass]="getFileStatus(file.sx)"></i></td>
              <td style="text-align:center"><i [ngClass]="getFileStatus(file.dx)"></i></td>
              <td>
                <p-progressbar *ngIf="file.isElaborating" showValue="false" [value]="file.progress" />
              </td>
              <td style="text-align:center">
                <p-button *ngIf="file.toElaborate" icon="fas fa-hammer" [loading]="file.isElaborating" [disabled]="file.isElaborating" (click)="onElaborate(file)" />
              </td>
              <td style="text-align:center">
                <p-button *ngIf="file.toShow" icon="far fa-map" (click)="onNavigate(file)"  [disabled]="file.isElaborating"/>
              </td>
              <td style="text-align:center">
                <p-button icon="far fa-trash-can" (click)="onDelete($event, file)" severity="danger" [outlined]="true"  [disabled]="file.isElaborating" />
              </td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td colspan="5">Nessun file caricato per questa sessione!</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<p-dialog header="Header"
          [(visible)]="showDialog"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false">
  <ng-template pTemplate="header">
    <div class="flex w-full flex-col justify-center gap-3">
      <label class="font-bold">Carica i file della sessione</label>
      <hr />
    </div>
  </ng-template>

  <div class="grid grid-cols-3 items-center gap-3">
    <label for="user" class="text-left font-semibold">Atleta</label>
    <p-select id="user" [options]="userOptions" optionLabel="value" [(ngModel)]="selectedUser" class="col-span-2 text-left" appendTo="body" (onChange)="onUserSelected($event)" />

    <label for="mass" class="text-left font-semibold">Peso [kg]</label>
    <p-inputnumber inputId="mass" [(ngModel)]="selectedItem.mass" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="3" />

    <label for="head" class="col-start-1 text-left font-semibold">File Testa</label>
    <p-fileUpload name="fileHead" class="col-span-2 justify-self-start"
                  mode="basic"
                  [accept]="acceptedFiles"
                  [maxFileSize]="maxFileSize"
                  [auto]="false"
                  [customUpload]="true"
                  [chooseLabel]="'Seleziona file'"
                  (onSelect)="onFileSelect($event, 1)">
    </p-fileUpload>

    <label for="footDx" class="col-start-1 text-left font-semibold">File Piede Destro</label>
    <p-fileUpload name="fileDx" class="col-span-2 justify-self-start"
                  mode="basic"
                  [accept]="acceptedFiles"
                  [maxFileSize]="maxFileSize"
                  [auto]="false"
                  [customUpload]="true"
                  [chooseLabel]="'Seleziona file'"
                  (onSelect)="onFileSelect($event, 3)">
    </p-fileUpload>

    <label for="footSx" class="col-start-1 text-left font-semibold">File Piede Sinistro</label>
    <p-fileUpload name="fileSx" class="col-span-2 justify-self-start"
                  mode="basic"
                  [accept]="acceptedFiles"
                  [maxFileSize]="maxFileSize"
                  [auto]="false"
                  [customUpload]="true"
                  [chooseLabel]="'Seleziona file'"
                  (onSelect)="onFileSelect($event, 2)">
    </p-fileUpload>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Chiudi"
              severity="secondary"
              variant="outlined"
              (click)="onCloseDialog()" />
    <p-button label="Carica"
              [loading]="uploading"
              (click)="onUpload()" />
  </ng-template>
</p-dialog>
